var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGra02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "301.57mm",
    height: "301.57mm",
    viewBox: "0 0 854.84 854.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M336.71,310.13c-6.9-20.17-6.66-42.37-1.54-63.07,11.83-47.85,52.39-88.68,101.13-95.97,49.8-7.44,101.13,20.77,127.8,63.48s30.5,97.18,17.35,145.78-41.93,91.8-76.17,128.72c-23.9,25.77-50.75,49.06-71.08,77.73-20.33,28.67-33.81,64.62-26.3,98.96,7.82,35.71,38.31,64.2,73.46,74.24s73.82,3.09,106.01-14.23c36.53-19.64,64.88-51.27,97.53-76.85,32.65-25.58,74.12-45.87,114.55-36.63",
    fill: "none",
    stroke: "#62379f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M427.42,22c54.74,0,107.83,10.72,157.8,31.85,48.27,20.42,91.63,49.65,128.87,86.89s66.48,80.6,86.89,128.87c21.13,49.97,31.85,103.06,31.85,157.8s-10.72,107.83-31.85,157.8c-20.42,48.27-49.65,91.63-86.89,128.87s-80.6,66.48-128.87,86.89c-49.97,21.13-103.06,31.85-157.8,31.85s-107.83-10.72-157.8-31.85c-48.27-20.42-91.63-49.65-128.87-86.89s-66.48-80.6-86.89-128.87c-21.13-49.97-31.85-103.06-31.85-157.8s10.72-107.83,31.85-157.8c20.42-48.27,49.65-91.63,86.89-128.87s80.6-66.48,128.87-86.89c49.97-21.13,103.06-31.85,157.8-31.85M427.42,0C191.36,0,0,191.36,0,427.42s191.36,427.42,427.42,427.42,427.42-191.36,427.42-427.42S663.47,0,427.42,0h0Z",
    fill: "#b9a2e2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M519.81,245.85c-10.55-5.43-22.86-8.25-35.52-6.95-18.11,1.86-30.67,10.96-38,26.87-2.67,5.79-8.07,10.42-14.69,12.5l-77.44,24.33-9.4,2.95-77.44,24.33c-6.62,2.08-13.7,1.38-19.2-1.85-15.11-8.86-30.62-9.14-46.54-.31-11.13,6.17-19.62,15.53-25.17,26.02-105,198.42,111.27,350.33,110.96,125.57,11.83,18.66,51.27,7.3,53.02-9.64,.41-4,4.4-8.4,8.75-9.76l43.67-13.72,2.39-.75,43.67-13.72c4.35-1.37,10.13-.04,12.76,3.01,11.12,12.9,49.97-.34,49-22.41,128.29,184.55,218.82-63.76,19.21-166.47Z",
    fill: "#b9a2e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.58,363.2l-88.39,27.77c-12.37,3.89-25.24,.02-30.59-9.18l-27.33-47,161.7-50.81,4.46,54.18c.87,10.62-7.47,21.14-19.84,25.03Z",
    fill: "#62379f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.93,
    cy: 452.97,
    r: 20.26,
    fill: "#62379f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 465.83,
    cy: 403.68,
    r: 20.26,
    fill: "#62379f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.6,
    cy: 285.61,
    r: 11.92,
    fill: "#62379f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.27,
    cy: 338.67,
    r: 11.92,
    fill: "#62379f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 546.46,
    cy: 303.81,
    r: 11.92,
    fill: "#62379f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 493.4,
    cy: 320.48,
    r: 11.92,
    fill: "#62379f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.08,385.8l-5.49,8.02c-.42,.61-1.21,.84-1.89,.56l-8.52-3.58c-.42-.18-.75-.53-.88-.97l-5.42-17.25c-.6-1.91,.46-3.95,2.37-4.55l10.07-3.16c1.91-.6,3.95,.46,4.55,2.37l5.41,17.22c.14,.46,.07,.95-.2,1.35Z",
    fill: "#62379f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.49,413.9l5.49-8.02c.42-.61,1.21-.84,1.89-.56l8.52,3.58c.42,.18,.75,.53,.88,.97l5.42,17.25c.6,1.91-.46,3.95-2.37,4.55l-10.07,3.16c-1.91,.6-3.95-.46-4.55-2.37l-5.41-17.22c-.14-.46-.07-.95,.2-1.35Z",
    fill: "#62379f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.84,404.15l-8.02-5.49c-.61-.42-.84-1.21-.56-1.89l3.58-8.52c.18-.42,.53-.75,.97-.88l17.25-5.42c1.91-.6,3.95,.46,4.55,2.37l3.16,10.07c.6,1.91-.46,3.95-2.37,4.55l-17.22,5.41c-.46,.14-.95,.07-1.35-.2Z",
    fill: "#62379f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.73,395.55l8.02,5.49c.61,.42,.84,1.21,.56,1.89l-3.58,8.52c-.18,.42-.53,.75-.97,.88l-17.25,5.42c-1.91,.6-3.95-.46-4.55-2.37l-3.16-10.07c-.6-1.91,.46-3.95,2.37-4.55l17.22-5.41c.46-.14,.95-.07,1.35,.2Z",
    fill: "#62379f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGra02);
export default __webpack_public_path__ + "static/media/gra-02.ef76310b270d738bb3114def0637aed0.svg";
export { ForwardRef as ReactComponent };